import {initializeApp} from 'firebase/app';
import {initializeFirestore} from 'firebase/firestore';

import Constant from 'utils/Constant';

export const firebaseApp = initializeApp(Constant.firebaseConfig);
const firestore = initializeFirestore(firebaseApp, {});

export enum Collection {
  User = 'users',
  Checkout = 'checkout_sessions',
  Subscriptions = 'subscriptions'
}

export default firestore;
